import * as React from "react";
import { Project } from "src/redux/projects";
import { WithNamespaces, withNamespaces } from "react-i18next";
import {Badge, Table} from "reactstrap";
import { FaPen } from 'react-icons/fa'

import { Link } from "react-router-dom";
// import { Loader } from "./Loader";
import { translateAvancement } from "src/helpers/translateAvancementPrestation";
// import { HeaderPage } from "./HeaderPage";


interface Props {
  project: Project;
}
type PropsWithNamespaces = Props & WithNamespaces;
class ProjectPage extends React.Component<PropsWithNamespaces> {
    actionTable(){
        return <div className="table-presta-projet">
            <div className="header-table-presta-projet">
                Actions à effectuer <Badge color="alert">{this.props.project.prestationsAction.length}</Badge>
            </div>
            <Table>
                <thead>
                <tr>
                    <th>Prestation</th>
                    <th>Date d'envoi</th>
                    <th>Action attendue</th>
                    <th>Technicien</th>
                    <th>Action</th>
                </tr>
                </thead>
                <tbody>
                {this.props.project.prestationsAction.map(this.actionRow.bind(this))}
                </tbody>
            </Table>
        </div>
    }
    translateType = proposalType => {
        const TabPrestationStatus = {
            Artwork: "Annotez votre illustration",
            POV: "Choisissez votre angle de vue",
            PlanDecoration: "Choisissez votre décoration"
        };
        return TabPrestationStatus[proposalType];
    };
    actionRow(action){
        const prestation=this.props.project.prestations.find(
            p => action.prestation_id === p.id
        );
        console.log('prestation',prestation);
        console.log('action',action);
        if(!prestation){
            return <></>
        }
        return <tr key={action.id}>
                <td>{prestation.type_prestation} {prestation.name && ': '+prestation.name}</td>
                <td>{action.date_crea.format("DD MMM YYYY")}</td>
                <td>{this.translateType(action.type)}</td>
                <td>{action.auteur}</td>
                <td className='action-cell'>
                    <Link className="text-decoration-none"
                        to={{
                            pathname: `/projects/${this.props.project.id}/prestation/${prestation.id}`
                        }}
                    >
                        <FaPen size='1em' /><br/>Accéder
                    </Link>
                </td>
            </tr>
    }
    prestationTable(){
        return <div className="table-presta-projet">
            <div className="header-table-presta-projet">
                Les prestations
            </div>
            <Table>
                <thead>
                <tr>
                    <th>Vignette</th>
                    <th>Prestation</th>
                    <th>Date de rendu</th>
                    <th>Avancement</th>
                    <th>Action</th>
                </tr>
                </thead>
                <tbody>
                {this.props.project.prestations.map(this.prestationRow.bind(this))}
                </tbody>
            </Table>
        </div>
    }
    prestationRow(p){
        return <tr key={p.id}>
                <td>
                    {!p.image && (
                        <img
                            className="default"
                            src="assets/presta-defaut.jpg"
                        />
                    )}
                    {p.image && <img src={p.image} />}
                </td>
                <td>{p.type_prestation} {p.name && ': '+p.name}</td>
                <td>{p.dueDate.format("DD MMM YYYY")}</td>
                <td>{translateAvancement(p.status, this.props)}</td>
                <td className='action-cell'>
                    <Link className="text-decoration-none"
                          to={{
                              pathname: `/projects/${this.props.project.id}/prestation/${p.id}`
                          }}
                    >
                        <FaPen size='1em' /><br/>Accéder
                    </Link>
                </td>
            </tr>
    }
    render() {
        return <div className='content-projet'>
            {this.actionTable()}
            {this.prestationTable()}
        </div>
    }
}
/*class ProjectPage extends React.Component<PropsWithNamespaces> {
    prestationWithoutAction(p){
        return <div className="col-12 col-lg-3 pr-4 pb-5" key={p.id}>
            <Link
                className="text-decoration-none"
                to={{
                    pathname: `/projects/${this.props.project.id}/prestation/${p.id}`
                }}
            >
                <div className="card card-project">
                    <div className="card-header">
                        <div className="card-header-img">
                            {!p.image && (
                                <img
                                    className="default"
                                    src="assets/presta-defaut.jpg"
                                />
                            )}
                            {p.image && <img src={p.image} />}
                        </div>
                    </div>
                    <div>
                        <p className="avancement">
                            {translateAvancement(p.status, this.props)}
                        </p>
                    </div>
                    <div className="card-body d-flex flex-column">
                        <div className="flex-1">
                            <p className="mb-0 title">{p.type_prestation}</p>
                        </div>
                    </div>
                </div>
            </Link>
        </div>
    }
  prestationWithAction(p) {
        const action=this.props.project.prestationsAction.find(
            a => a.prestation_id === p.id
        )||{
            thumbUrl:'',
            type:'',
        };
    return <div className="col-12 col-lg-3 pr-4 pb-5" key={p.uuid}>
      <Link
        className="text-decoration-none"
        to={{
          pathname: `/projects/${this.props.project.id}/prestation/${p.id}`
        }}
      >
        <div className="card card-project">
          <div className="card-header">
            <div className="card-header-img">
              {!action.thumbUrl && action.type !== "PlanDecoration" && (
                <img
                  className="default"
                  src="assets/presta-defaut.jpg"
                />
              )}
              {!action.thumbUrl && action.type === "PlanDecoration" && (
                <img
                  className="default"
                  src="assets/decoration-defaut.jpg"
                />
              )}
              {action.thumbUrl && <img src={action.thumbUrl} />}
            </div>
          </div>
          <div>
            <p
              className={`avancement ${
                p.type === "PlanDecoration"
                  ? "draft"
                  : p.status.toLowerCase()
              }`}
            >
              {p.type !== "PlanDecoration" &&
                translateAvancement(
                  p.status,
                  this.props,
                  p.type
                )}
              {p.type === "PlanDecoration" &&
                this.props.t(
                  "project.prestations.avancements.draftDeco"
                )}
            </p>
          </div>

          <div className="card-body d-flex flex-column">
            <div className="flex-1">
              <p className="mb-0 title">{p.name}</p>
            </div>
          </div>
        </div>
      </Link>
    </div>
  }
  hasAction(p){
      return this.props.project.prestationsAction.some(
          action => action.prestation_id === p.id
      );
  }
  render() {
    return (
      <div>
        <div className="mb-4">
          <HeaderPage title={this.props.project.name} back={true} />
        </div>
        <div className="container-fluid">
          <div className="row">
              {this.props.project.isLoadingPrestations && <Loader />}
              {this.props.project.prestations.map(p=>(
                    this.hasAction(p) ?  this.prestationWithAction(p): this.prestationWithoutAction(p)
              ))}
            </div>
          </div>
      </div>
    );
  }
}
 */
export default withNamespaces()(ProjectPage);



// WEBPACK FOOTER //
// ./src/components/Project.tsx